/**
 * Shared financial tolerances for the household custom-allocation editor.
 * Values match holding-service `setCustomExpectedPercentages.ts`.
 *
 * Kept as separately named constants even when numeric values coincide —
 * weight-sum checks and override-diff checks must be tunable independently.
 */

/** Column weight sum vs securityMassFraction / row weight balance. */
export const ALLOCATION_WEIGHT_TOLERANCE = 0.0001;

/**
 * Draft or persisted override vs model/displayed fraction —
 * "changed vs unchanged" detection for save diffs and dirty state.
 */
export const CUSTOM_OVERRIDE_TOLERANCE = 0.0001;

/** Per-member cents budget for AGGREGATE_CONSERVATION-style row drift. */
export const CENTS_TOLERANCE_PER_MEMBER = 10;

export const dollarToleranceCents = (memberCount: number) =>
  CENTS_TOLERANCE_PER_MEMBER * memberCount;
